// Écran déjà vu (réglage « première visite uniquement ») : on le masque tout de suite,
// sans attendre le chargement du DOM, pour éviter tout flash sur les pages suivantes.
(function () {
  try {
    var settings = window.loadingScreenSettings;
    var element = document.getElementById('loading-screen');
    if (settings && settings.showOnlyFirstVisit && element && localStorage.getItem('loading-screen-visited')) {
      element.classList.remove('loading-screen--active');
      element.setAttribute('aria-hidden', 'true');
      element.style.display = 'none';
    }
  } catch (_) {}
})();

class LoadingScreen {
  constructor() {
    this.element = document.getElementById('loading-screen');
    if (!this.element || !window.loadingScreenSettings?.enabled) return;

    this.settings = window.loadingScreenSettings;
    this.startTime = Date.now();
    this.isFirstVisit = this.checkFirstVisit();
    window.addEventListener('pageshow', event => { if (event.persisted) this.hide(true); });


    if (this.settings.showOnlyFirstVisit && !this.isFirstVisit) {
      this.hide(true);
      return;
    }

    this.init();
  }

  init() {
    this.preloadImage();
    this.hideOnLoad();
  }

  preloadImage() {
    const image = this.element.querySelector('.loading-screen__image');
    if (image) {
      if (image.complete && image.naturalHeight !== 0) {
        // Image is already loaded from cache
        image.style.transition = 'none';
        image.style.opacity = '1';
        image.classList.add('loading-screen__image--loaded');
      } else {
        // Image needs to load
        image.style.opacity = '0';
        image.addEventListener('load', () => {
          requestAnimationFrame(() => {
            image.style.transition = 'opacity 0.3s ease-out';
            image.classList.add('loading-screen__image--loaded');
          });
        });
      }
    }
  }

  // Première visite = première fois sur ce navigateur (localStorage), et non plus à chaque session.
  checkFirstVisit() {
    try {
    const visited = localStorage.getItem('loading-screen-visited');
    if (!visited) {
      localStorage.setItem('loading-screen-visited', 'true');
      return true;
    }
    return false;
    } catch (_) { return true; }
  }

  hideOnLoad() {
    const hideLoader = () => {
      const elapsedTime = Date.now() - this.startTime;
      const remainingTime = Math.max(0, this.settings.minDuration - elapsedTime);
      setTimeout(() => {
        this.hide();
      }, remainingTime);
    };


    // Always wait for window load to ensure all resources are loaded
    if (document.readyState === 'complete') {
      // Page is already fully loaded
      hideLoader();
    } else {
      // Wait for the page to fully load
      window.addEventListener('load', hideLoader);
      
      // Also add a fallback timeout in case load event doesn't fire
      setTimeout(() => {
        if (this.element && this.element.classList.contains('loading-screen--active')) {
          this.hide();
        }
      }, 2000); // Bound the wait for external resources
    }
  }

  show(callback) {
    if (!this.element) return;

    // Reset display in case it was hidden
    this.element.style.display = '';
    
    // Force reflow
    this.element.offsetHeight;
    
    this.element.classList.add('loading-screen--active');
    this.element.setAttribute('aria-hidden', 'false');

    if (callback) {
      setTimeout(callback, 100);
    }
  }

  hide(immediate = false) {
    if (!this.element) return;

    const duration = immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : this.settings.fadeOutDuration;

    if (duration === 0) {
      this.element.classList.remove('loading-screen--active');
      this.element.setAttribute('aria-hidden', 'true');
      this.element.style.display = 'none';
    } else {
      // Remove the active class to trigger the CSS transition
      this.element.classList.remove('loading-screen--active');
      
      // Clean up after transition completes
      setTimeout(() => {
        this.element.setAttribute('aria-hidden', 'true');
        this.element.style.display = 'none';
      }, duration);
    }
  }
}

// Initialize immediately if DOM is already loaded, otherwise wait
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LoadingScreen();
  });
} else {
  // DOM is already loaded
  new LoadingScreen();
}
